"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var papaparse_1 = __importDefault(require("papaparse"));
/**
 * Converts object Json like to CSV
 * Ex:
 * const myContent = [
 *  {
 *    "Column 1": "value"
 *    "Column 2": "value"
 *  },
 *  {
 *    "Column 1": "value"
 *    "Column 2": "value"
 *  },
 * ]
 *
 * @param content array of objects containing the csv structure
 */
var arrayObjectsToCSV = function (content) {
    return papaparse_1.default.unparse(content);
};
exports.arrayObjectsToCSV = arrayObjectsToCSV;
//# sourceMappingURL=csv.js.map